/**
 * GMCC Specials → Diamond（/app/gmccdiamond）。
 * 打开页面打 STATSIG.COMMON.VIEW，value=diamond。
 *
 * 正在用：打开 Diamond；点外部 Collateral Analytics 链接。
 * 已不算：文案。Program maps / Flyers hub 里的 Diamond flyer 不跨到这里。
 */
export enum GmccDiamondEvent {
    /** 点 Collateral Analytics 链接 */
    OPEN = 'DIAMOND_OPEN',
}
